import React from 'react';
import { Panel, Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import SortContainer from './SortContainer';
import SortItem from './SortItem';
import Spinner from '../../../../../components/Loaders/Spinner';

const RepliesTable = ({ items, toggleModal, onSortEnd, setModalText, setValues, hideHandle, loading }) => {
  const onEditReply = (item) => {
    setValues({ title: item.title, body: item.body, ...item });
    setModalText({
      type: 'edit',
      title: 'Edit reply',
      okBtnText: 'Save changes',
    });
    toggleModal();
  };

  return (
    <Panel className="replies-list">
      <Table className="replies-head">
        <thead>
          <tr>
            {!hideHandle && <th className="replies-head__handle"> </th>}
            <th className="replies-head__title">Title</th>
            <th className="replies-head__body">Text</th>
            <th className="replies-head__delete"> </th>
          </tr>
        </thead>
      </Table>
      <div className="position-relative">
        {loading && (
          <div className="replies-list__loader">
            <Spinner />
          </div>
        )}
        <SortContainer onSortEnd={onSortEnd} useDragHandle helperClass="on-drag">
          {items?.map((item, index) => (
            <SortItem
              key={item.id}
              index={index}
              item={item}
              onEditReply={onEditReply}
              hideHandle={hideHandle}
              collection={item.default ? 1 : 0}
              disabled={item.default}
            />
          ))}
        </SortContainer>
      </div>
    </Panel>
  );
};

RepliesTable.propTypes = {
  items: PropTypes.array,
  onSortEnd: PropTypes.func,
  toggleModal: PropTypes.func,
  setModalText: PropTypes.func,
  setValues: PropTypes.func,
  hideHandle: PropTypes.bool,
  loading: PropTypes.bool,
};

export default RepliesTable;
